import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ILeasingPreferences } from '../../../../shared/models/leasing-preferences.model';
import { AccordionModule } from 'primeng/accordion';
import { InformationEntityComponent } from '../../../../shared/components/information-entity/information-entity.component';
import { MonthsAmountPipe } from '../../pipes/months-amount.pipe';
import { HasPetsLabelPipe } from '../../pipes/has-pets-label.pipe';
import { DesiredPriceRangePipe } from '../../pipes/desired-price-range.pipe';

@Component({
  selector: 'cv-leasing-preferences',
  standalone: true,
  imports: [AccordionModule, InformationEntityComponent, MonthsAmountPipe, HasPetsLabelPipe, DesiredPriceRangePipe],
  template: `
    <p-accordionTab [selected]="true" contentStyleClass="info-card" header="Leasing Preferences">
      <cv-information-entity label="Desired Bedrooms" [value]="data.desiredBedrooms" />
      <cv-information-entity label="Desired Bathrooms" [value]="data.desiredBathrooms" />
      <cv-information-entity label="Number of Occupants" [value]="data.numberOfOccupants" />
      <cv-information-entity label="Desired Lease terms" [value]="data.desiredLeaseTerms | monthsAmountLabel" />
      <cv-information-entity
        label="Desired Price Range"
        [value]="data.desiredPriceRangeFrom | desiredPriceRange: data.desiredPriceRangeTo"
      />
      <cv-information-entity label="Desired Move-In Date" [value]="data.moveInDate" />
      <cv-information-entity label="Has Pets" [value]="data.hasPets | hasPetsLabel" />
      <cv-information-entity label="Amenity Interests" [value]="data.amenityInterests" />
    </p-accordionTab>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeasingPreferencesComponent {
  @Input({ required: true }) data: ILeasingPreferences = {} as ILeasingPreferences;
}
